import { Box, Image, Text, HStack, VStack, Icon } from "@chakra-ui/react";
import { FaFutbol, FaMedal } from "react-icons/fa";

interface PlayerCardProps {
  photoUrl: string;
  name: string;
  goals: number;
  textGoal: string;
  position?: number;
  ownGoal?: boolean;
}

export const PlayerCard = ({
  photoUrl,
  name,
  goals,
  textGoal,
  position,
  ownGoal = false,
}: PlayerCardProps): JSX.Element => {
  const displayGoals = ownGoal ? -Math.abs(goals) : goals;

  const isTopThree =
    typeof position === "number" &&
    (position === 1 || position === 2 || position === 3);

  const medalColor =
    position === 1 ? "#FFD700" : position === 2 ? "#C0C0C0" : "#CD7F32";

  const positionLabel =
    typeof position === "number" ? `posição ${position}` : undefined;

  const outerHStackProps: any = {
    align: "center",
    p: 2,
    w: "full",
    justifyContent: "space-between",
  };
  const leftHStackProps: any = { spacing: 4, align: "center" };
  const goalsHStackProps: any = { spacing: 1, align: "center" };

  // Cast Chakra layout components to `any` variants to avoid heavy union types in JSX
  const HStackAny: any = HStack as any;
  const VStackAny: any = VStack as any;

  // Extract complex JSX into local variables to further simplify type resolution.
  const leftContent = (
    <HStackAny {...leftHStackProps}>
      <Image
        borderRadius="full"
        boxSize="50px"
        src={photoUrl}
        alt={`${name} photo`}
      />
      <VStackAny align="start">
        <Text fontSize="xl" fontWeight="bold">
          {name}
        </Text>
        <HStackAny spacing={2} align="center">
          <Text fontSize="md">{textGoal}:</Text>
          <HStackAny {...goalsHStackProps}>
            <Icon
              as={FaFutbol as any}
              boxSize={4}
              color={ownGoal ? "red.500" : "yellow.400"}
              aria-label={ownGoal ? "own goal" : "bola"}
            />
            <Text fontSize="md">{displayGoals}</Text>
          </HStackAny>
        </HStackAny>
      </VStackAny>
    </HStackAny>
  );

  const rightContent =
    typeof position === "number" ? (
      <Box>
        <HStackAny spacing={2} align="center">
          {isTopThree ? (
            <Icon
              as={FaMedal as any}
              boxSize={10}
              color={medalColor}
              aria-label={positionLabel}
            />
          ) : (
            <Box
              w="32px"
              h="32px"
              bg="green.500"
              color="white"
              borderRadius="full"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Text fontSize="sm" fontWeight="bold">{`${position}`}</Text>
            </Box>
          )}
        </HStackAny>
      </Box>
    ) : null;

  return (
    <Box w="100%" bg="primary.800" textAlign="center" borderRadius="md">
      <HStack {...outerHStackProps}>
        {leftContent}
        {rightContent}
      </HStack>
    </Box>
  );
};
